
import NativeClient from "@/client/native-client";
import { defineComponent, SetupContext, computed } from "vue";

export default defineComponent({
  name: "DetailMyApplianceView",
  props: {
    isLogin: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context: SetupContext) {
    const onClickMyApplianceLink = () => {
      NativeClient.sendDebugLog("DetailMyApplianceView onClickMyApplianceLink");
      context.emit("click-my-appliance-link");
    };
    const getMessage = () => {
      return props.isLogin
        ? "機器連携されていないか、連携中の機器に対応したレシピがありません。対象機器を家電登録し機器連携の設定をONすることで、連携された機器のレシピが表示されます。"
        : "ログインして、対象機器を家電登録し機器連携の設定をONすることで、連携された機器のレシピが表示されます。";
    };
    return {
      onClickMyApplianceLink,
      getMessage
    };
  }
});
